import { ArrowRight, CalendarDays, PackageCheck, Truck } from 'lucide-react';
import { Link } from 'react-router';
import {
  formatDate,
  formatMoney,
  frequencyLabel,
  subscriptionStatusLabels,
  subscriptionStatusTone,
} from '../lib/format';
import type { SubscriptionSummary } from '../lib/schemas';
import { Badge, Card, DefinitionItem } from './ui';

export function SubscriptionCard({ subscription }: { subscription: SubscriptionSummary }) {
  return (
    <Card className="subscription-card">
      <div aria-hidden="true" className="subscription-card__visual">
        <span className="fruit fruit--one" />
        <span className="fruit fruit--two" />
        <span className="fruit fruit--three" />
        <span className="subscription-card__weight">{subscription.plan.variantLabel}</span>
      </div>
      <div className="subscription-card__content">
        <div className="subscription-card__topline">
          <Badge tone={subscriptionStatusTone(subscription.status)}>
            {subscriptionStatusLabels[subscription.status]}
          </Badge>
          <span className="subscription-card__price">{formatMoney(subscription.amountMinor)}</span>
        </div>
        <h2>{subscription.plan.name}</h2>
        <p className="muted">
          {subscription.plan.variantLabel} · {frequencyLabel(subscription.plan)}
        </p>
        <dl className="subscription-card__facts">
          <DefinitionItem
            label="Sıradaki tahsilat"
            value={
              <span>
                <CalendarDays aria-hidden="true" size={16} />{' '}
                {formatDate(subscription.nextPaymentAt)}
              </span>
            }
          />
          <DefinitionItem
            label="Son sipariş"
            value={
              subscription.lastOrder ? (
                <span>
                  <PackageCheck aria-hidden="true" size={16} /> {subscription.lastOrder.name}
                </span>
              ) : (
                'Henüz oluşmadı'
              )
            }
          />
        </dl>
        {subscription.status === 'PAST_DUE' ? (
          <p className="subscription-card__warning">
            Kartınızı güncelledikten sonra tahsilat güvenle yeniden değerlendirilebilir.
          </p>
        ) : null}
        <Link className="subscription-card__link" to={`/subscriptions/${subscription.id}`}>
          Aboneliği yönet <ArrowRight aria-hidden="true" size={18} />
        </Link>
      </div>
    </Card>
  );
}

export function DeliveryPromise() {
  return (
    <div className="delivery-promise">
      <Truck aria-hidden="true" size={22} />
      <div>
        <strong>Dalından kapınıza</strong>
        <span>Her kutu ödeme onayından sonra taze hazırlanır.</span>
      </div>
    </div>
  );
}

interface MetricCardProps {
  label: string;
  value: string;
  detail: string;
  tone?: 'default' | 'warning' | 'danger';
}

export function MetricCard({ label, value, detail, tone = 'default' }: MetricCardProps) {
  return (
    <Card className={`metric-card metric-card--${tone}`}>
      <span>{label}</span>
      <strong>{value}</strong>
      <small>{detail}</small>
    </Card>
  );
}
